import React from 'react'

import {
  default as reducer,
  initialState,
  getBackwardLocation,
  getForwardLocation,
} from './reducer'

import { useHistoryButtonClickCallback, useDocTitleOrDefault } from './hooks'
import HistoryButtonsLayout from './Layout'
import HistoryButtonsSync from './Sync'

// Even if history buttons are unmounted,
// we keep their previous state in memory
let sessionState = initialState

export default React.memo(function HistoryButtons() {
  const [state, dispatch] = React.useReducer(reducer, sessionState)
  sessionState = state

  const backwardLocation = getBackwardLocation(state)
  const forwardLocation = getForwardLocation(state)

  const backwardLabel = useDocTitleOrDefault(backwardLocation, 'Previous doc')
  const forwardLabel = useDocTitleOrDefault(forwardLocation, 'Next doc')

  const onClickBackward = useHistoryButtonClickCallback(
    backwardLocation,
    '?backward'
  )
  const onClickForward = useHistoryButtonClickCallback(
    forwardLocation,
    '?forward'
  )

  return (
    <React.Fragment>
      <HistoryButtonsSync dispatch={dispatch} />
      <HistoryButtonsLayout
        hasBackwardLocation={Boolean(backwardLocation)}
        hasForwardLocation={Boolean(forwardLocation)}
        backwardLabel={backwardLabel}
        forwardLabel={forwardLabel}
        onClickBackward={onClickBackward}
        onClickForward={onClickForward}
      />
    </React.Fragment>
  )
})
